import { render, staticRenderFns } from "./SupportSwitchAccount.vue?vue&type=template&id=3003d413&scoped=true"
import script from "./SupportSwitchAccount.vue?vue&type=script&lang=ts"
export * from "./SupportSwitchAccount.vue?vue&type=script&lang=ts"
import style0 from "./SupportSwitchAccount.vue?vue&type=style&index=0&id=3003d413&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3003d413",
  null
  
)

export default component.exports